<template>
  <div class="block">
    <header>
      <div class="back" @click="backToHome">返回上一页</div>
    </header>
    <div class="dataTable">
      <div class="tableHead">
        <div class="tabHeadLeft">
          <h4>订单查询</h4>
          <span>仅支持查询近一年的订单</span>
        </div>
        <div class="tabHeadRight">
          <span class="labelName">订单状态</span>
          <el-select v-model="orderState" @change="selectStateChange">
            <el-option
              v-for="item in StateOptions.slice(0, 6)"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <el-table :data="dataList" border stripe>
        <el-table-column
          v-for="col in tableColums"
          :prop="col.id"
          :key="col.id"
          :label="col.label"
          :width="col.width ? col.width : 'auto'"
        >
          <template v-if="col.id === 'optioner'" #default="scope">
            <span class="showDetail" @click="showDetail(scope.row)">
              查看详情
            </span>
          </template>
          <template v-else-if="col.id === 'state'" #default="scope">
            <el-link
              :underline="false"
              type="primary"
              v-if="scope.row.state === STATUS.AUDITING"
            >
              {{ scope.row.state | getStatusText }}
            </el-link>
            <el-link
              :underline="false"
              type="success"
              v-else-if="
                scope.row.state === STATUS.EXCHANGED ||
                scope.row.state === STATUS.DEAL
              "
            >
              {{ scope.row.state | getStatusText }}
            </el-link>
            <el-popover
              v-else-if="scope.row.state === STATUS.CLOSED"
              placement="bottom"
              title="拒绝原因"
              width="200"
              trigger="click"
              :content="scope.row.close_remarks"
            >
              <el-link slot="reference" type="info">
                {{ scope.row.state | getStatusText }}
              </el-link>
            </el-popover>
            <el-link :underline="false" type="info" v-else>
              {{ scope.row.state | getStatusText }}
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="data-filter-page">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pagination.page_size"
          @size-change="allPageSizeChange"
          @current-change="allDataPageChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="订单详情" :visible.sync="showDetailDialog" width="600px">
      <div class="orderDetails">
        <div class="row">
          <div class="rowLabel">订单编号</div>
          <div class="rowValue">{{ orderDetail.id }}</div>
        </div>
        <div class="row">
          <div class="rowLabel">订单状态</div>
          <div class="rowValue">{{ orderDetail.state | getStatusText }}</div>
        </div>
        <div class="row">
          <div class="rowLabel">收件人</div>
          <div class="rowValue" v-if="orderDetail.goods_type === 1">
            {{ orderDetail.buyer_name }}
          </div>
          <div class="rowValue" v-else>
            {{ orderDetail.uin_name }}（{{ orderDetail.uin }}）
          </div>
        </div>
        <div class="row" v-if="orderDetail.goods_type === 1">
          <div class="rowLabel">收件人手机号</div>
          <div class="rowValue">{{ orderDetail.buyer_phone }}</div>
        </div>
        <div class="row">
          <div class="rowLabel">收货方式</div>
          <template v-if="orderDetail.goods_type === 1">
            <div class="rowValue" v-if="orderDetail.email_id">
              快递单号：{{ orderDetail.email_id }}
            </div>
            <div class="rowValue" v-else>快递单号待更新</div>
          </template>
          <div class="rowValue" v-else>虚拟商品，系统发放至游戏邮箱</div>
        </div>
        <div class="row" v-if="orderDetail.buyer_address">
          <div class="rowLabel">收货地址</div>
          <div class="rowValue">{{ orderDetail.buyer_address }}</div>
        </div>
      </div>
      <div class="productionCard">
        <img :src="orderDetail.image" />
        <el-table :data="orderDetailTable">
          <el-table-column prop="name" key="name" label="商品名称" />
          <el-table-column
            prop="time"
            key="time"
            label="下单时间"
            width="160px"
          />
          <el-table-column prop="price" key="price" label="价格" />
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mixins from '../../../mixins/exchangeShop/orderList.mixins';

export default {
  mixins: [mixins],
};
</script>
<style src="../../../style/common-pc.scss" lang="scss" scoped></style>
<style
  src="../../../style/exchange-shop/pc/common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.dataTable {
  // border-top: 1px solid #d9d9d9;
  margin: 0 auto 0;
  // padding-top: 32px;
}
.tableHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 27px;
  .tabHeadLeft {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    flex: 1 0 auto;
    h4 {
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #262626;
      line-height: 33px;
      margin-right: 20px;
    }
    span {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 20px;
    }
  }
  .tabHeadRight {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .labelName {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 20px;
      margin-right: 14px;
    }
  }
}
.showDetail {
  color: #3b9aff;
  cursor: pointer;
}
.el-link.el-link--primary {
  color: #3b9aff;
}
::v-deep .el-dialog__header {
  padding: 20px 32px 10px;
}
::v-deep .el-dialog__body {
  padding: 18px 36px 46px;
}
.orderDetails {
  .row {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: rgba(89, 89, 89, 1);
    margin-bottom: 18px;
  }
}
.productionCard {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  width: 520px;
  min-height: 159px;
  background: #fffcf4;
  border-radius: 6px;
  border: 1px solid #ffcc40;
  margin: auto;
  padding: 14px;
  img {
    width: 100px;
    height: 100px;
    margin-right: 6px;
    border-radius: 4px;
  }
  ::v-deep .el-table {
    background: #fffcf4;
    &::before {
      display: none;
    }
    tr,
    th {
      background: #fffcf4;
      color: #595959;
      text-align: center;
    }
    tbody tr {
      // padding: 32px 0;
      td {
        font-weight: 500;
        padding: 35px 0;
        text-align: center;
        border: none;
      }
    }
  }
}
</style>
